import { render, staticRenderFns } from "./AdGooglePay.vue?vue&type=template&id=f082cf4a&scoped=true"
import script from "./AdGooglePay.vue?vue&type=script&lang=js"
export * from "./AdGooglePay.vue?vue&type=script&lang=js"
import style0 from "./AdGooglePay.vue?vue&type=style&index=0&id=f082cf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f082cf4a",
  null
  
)

export default component.exports